import axios from 'axios';
import { SetterOrUpdater } from 'recoil';
import { environment } from '../../environment';
import { ReceiveKlaviyoResponsePayload, SubscribeToKlaviyoPayload } from '../../models/klaviyo/SubscribeToKlaviyo';
import { trackEmailSubscriptionCompleted } from '../../tracking/events';

const useEmailSubscribe = (): ((
  payload: SubscribeToKlaviyoPayload,
  setKlaviyoStatus: SetterOrUpdater<ReceiveKlaviyoResponsePayload | undefined>,
) => Promise<void>) => {
  return async (payload: SubscribeToKlaviyoPayload, setKlaviyoStatus: SetterOrUpdater<ReceiveKlaviyoResponsePayload | undefined>) => {
    trackEmailSubscriptionCompleted();
    if (payload.isBackInStockSubscription) {
      const body = new FormData();
      body.set('a', payload.klaviyoSiteId);
      body.set('email', payload.email);
      body.set('g', payload.subscribeForNewsletter ? payload.klaviyoListId ?? '' : '');
      body.set('variant', `${payload.variantId}`);
      body.set('product', `${payload.productId}`);
      body.set('platform', 'shopify');
      body.set('subscribe_for_newsletter', `${payload.subscribeForNewsletter}`);
      axios
        .post<ReceiveKlaviyoResponsePayload>(environment.klaviyoBisUrl, body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {
          setKlaviyoStatus(response.data);
        });
    } else {
      const body = new FormData();
      body.set('a', payload.klaviyoSiteId);
      body.set('g', payload.klaviyoListId);
      // body.set('$fields', '$email,$consent_method,$consent_form_id,$services');
      // body.set('$consent_form_version', action?.payload?.consentFormVersion); // 939224
      body.set('$email', payload.email);
      body.set('$consent_method', 'Klaviyo Form');
      if (payload.subscribeForNewsletter) {
        body.set('subscribe_for_newsletter', `${payload.subscribeForNewsletter}`);
      } else {
        body.set('$fields', '$email,$consent_method,$consent_form_id,$services');
      }
      payload.klaviyoFormId && body.set('$consent_form_id', payload.klaviyoFormId);
      // body.set('$source', payload.source); // 4x5x
      body.set('$services', '{"shopify":{"source":"form"}}');
      axios
        .post<ReceiveKlaviyoResponsePayload>(environment.klaviyoSubscriptionUrl, body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {
          setKlaviyoStatus(response.data);
        });
    }
  };
};

export default useEmailSubscribe;
